<p-panel [style]="{width: '920px', maxWidth: '100%', margin: 'auto'}" [header]="this.jsonData?.domain">
  <app-wordpress-details [wordpressData]="wordpressData"></app-wordpress-details>
  <app-theme-details [themesData]="themesData"></app-theme-details>
  <p-tabs value="0" scrollable>
    <p-tablist>
      <p-tab value="0">
        <img src="/svg/test-results/plugins.svg"/>Plugins
      </p-tab>
      <p-tab value="1">
        <img src="/svg/test-results/pages.svg"/>Pages Scanned
      </p-tab>
      <p-tab *ngIf="accessibilityData" value="2">
        <img src="/svg/test-results/accessibility.svg"/>Accessibility
      </p-tab>
      <p-tab *ngIf="lighthouseData" value="3">
        <img src="/svg/test-results/lighthouse.svg"/>Lighthouse
      </p-tab>
      <p-tab *ngIf="chromeUXData?.score" value="4">
        <img  src="/svg/test-results/chrome.svg"/>Chrome UX
      </p-tab>
      <p-tab value="5">
        Hosting
      </p-tab>
      <p-tab *ngIf="securityData" value="6">
        Security
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-plugins-details [pluginsData]="pluginsData"></app-plugins-details>
      </p-tabpanel>
      <p-tabpanel value="1" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-pages-scanned [pagesScannedData]="pagesScannedData"></app-pages-scanned>
      </p-tabpanel>
      <p-tabpanel value="2" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-accessibility-details
          [accessibilityData]="accessibilityData"
          [testId]="testId">
        </app-accessibility-details>
      </p-tabpanel>
      <p-tabpanel value="3" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-lighthouse-details
          [lighthouseData]="lighthouseData"
          [testId]="testId"
        >
        </app-lighthouse-details>
      </p-tabpanel>

      <p-tabpanel value="4" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-crux-details [chromeUXData]="chromeUXData"/>
      </p-tabpanel>
      <p-tabpanel value="5" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-hosting-details [hostingData]="hostingData"></app-hosting-details>
      </p-tabpanel>
      <p-tabpanel value="6" class="bg-white dark:bg-gray-800 dark:text-white">
        <app-security-check [securityData]="securityData"></app-security-check>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</p-panel>

<div class="flex justify-center mt-4">
  <a href="{{ getFeedbackUrl() }}" class="bg-apricot-800 text-white px-4 py-2 rounded hover:bg-blue-600" target="_blank" rel="noopener noreferrer">
    Provide Feedback
  </a>
</div>
